import { Component, OnInit, OnDestroy, ChangeDetectorRef, ChangeDetectionStrategy, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store, Action } from '@ngrx/store';
import { Router } from '@angular/router';
import { MatDialogRef, MatPaginator } from "@angular/material";
import { Actions } from '@ngrx/effects';
import { Subscription, Subject, Observable } from 'rxjs';
import { StoreDataSource } from '../../core/services/StoreDataSource';
import * as actions from '../../pillar/dashboard/store/actions';
import { ModuleConfiguration } from '../submission.module.config';
import { AddSubmittingEntityModel } from '../models/AddSubmittingEntityModel';
import { SubmittingEntityModel } from '../models/SubmittingEntityModel';
import { ACTION_ERROR, ActionError } from '../../pillar/common/actions/ActionError';
import { ActionBase } from '../../core/store/action/ActionBase';
import { patternValidator } from "../../common/validators/patternValidator";
import { startWithSpaceValidator } from "../../common/validators/startWithSpaceValidator";
import { invalidCharactersValidator } from "../../common/validators/invalidCharactersValidator";
import { existingSubmittingEntityNameValidator } from "../../common/validators/existingSubmittingEntityNameValidator";
import { SubmittingEntityListModel } from '../models/SubmittingEntityListModel';
import * as fromStore from '../store/reducers';
import { LookupModel } from '../../common/models/LookupModel';
import { SubmittingEntityIdentifierModel } from '../models/SubmittingEntityIdentifierModel';
import { AppConfigurationService } from '../../core/services/AppConfigurationService';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'brd-add-submitting-entity-dialog',
  templateUrl: './add-submitting-entity-dialog.component.html',
  styleUrls: ['./add-submitting-entity-dialog.component.scss']
})
export class AddSubmittingEntityDialogComponent implements OnInit, OnDestroy {
  addForm: FormGroup;
  destroyed$: Subject<boolean> = new Subject<boolean>();
  loading: boolean;
  addActionIdentifier: string;
  dataSource: StoreDataSource<SubmittingEntityListModel>;
  allSubmittingEntities: string[] = [];
  loading$: Observable<boolean>;
  submittingEntities$: Observable<SubmittingEntityListModel[]>;

  constructor(private store: Store<any>,
    public dialogRef: MatDialogRef<AddSubmittingEntityDialogComponent>,
    private formBuilder: FormBuilder,
    private router: Router,
    private actions$: Actions,
    public appConfigurationService: AppConfigurationService
  ) {
    this.store.select(fromStore.getSubmittingEntityList)
      .subscribe(list => {
        if (this.allSubmittingEntities.length <= list.length) {
          this.allSubmittingEntities = list.map(se => se.name);
        }
      });

    this.store.dispatch(new actions.QueryListAction(ModuleConfiguration.moduleName,
      SubmittingEntityListModel,
      {
        page: 0,
        pageSize: 2000,
        sortDirection: "asc"
      }));

    this.addForm = this.formBuilder.group({
      name: ['', Validators.compose([
        Validators.required,
        startWithSpaceValidator(),
        invalidCharactersValidator(),
        existingSubmittingEntityNameValidator(this.allSubmittingEntities)
      ])],
      identifierType: [null],
      identifier: ['']
    });

    if (this.appConfigurationService.configuration.hasSubmittingEntityIdentifier) {
      this.addForm.controls['identifierType'].setValidators([Validators.required]);
      this.addForm.controls['identifier'].setValidators([
        Validators.compose([
          Validators.required,
          Validators.maxLength(50)
        ])]);
    }
  }

  ngOnInit() {
    this.actions$.ofType(actions.addSuccessType<AddSubmittingEntityModel>(ModuleConfiguration.moduleName, AddSubmittingEntityModel))
      .takeUntil(this.destroyed$)
      .subscribe((a: actions.AddSuccessAction<AddSubmittingEntityModel>) => {
        this.router.navigateByUrl('submitting-entity-workspace/' + a.payload.key);
        this.loading = false;
        this.addActionIdentifier = undefined;
        this.close();
      });

    this.actions$.ofType(ACTION_ERROR)
      .filter((a: ActionError) => this.addActionIdentifier && a.payload.action.identifier === this.addActionIdentifier)
      .takeUntil(this.destroyed$)
      .subscribe(() => {
        this.loading = false;
        this.addActionIdentifier = undefined;
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
  }

  add() {
    var identifier = new SubmittingEntityIdentifierModel();
    identifier.identifier = this.addForm.value.identifier;
    identifier.identifierType = this.addForm.value.identifierType;

    var model = new AddSubmittingEntityModel();
    model.name = this.addForm.value.name;
    model.identifier = identifier;

    var addAction = new actions.AddAction(ModuleConfiguration.moduleName, AddSubmittingEntityModel, { model: model });
    this.addActionIdentifier = addAction.identifier;
    this.store.dispatch(addAction);
    this.loading = true;
  }

  close() {
    this.dialogRef.close();
  }
}





// WEBPACK FOOTER //
// ./src/app/submission/components/add-submitting-entity-dialog.component.ts